<style lang="scss" scoped>
.slide-10 {
  background-image: url(../../../assets/module4/slide10/background-01.jpg);
  background-size: cover;
  background-position: center;
  height: calc(100% - 65px);
  padding-right: 160px;
  padding-top: 65px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
h1 {
  color: #3b7fc2;
  font-size: 64px;
  transform: rotate(-5deg);
  span {
    font-size: 104px;
    line-height: 124.8px;
  }
}
p.top {
  margin-top: 80px;
  max-width: 360px;
}
p {
  margin-bottom: 50px;
}
.content {
  max-width: 595px;
  margin-right: 93px;
}
.download {
  position: absolute;
  display: block;
  right: 900px;
  top: 300px;
  transition: all 0.2s ease-out;
  &:hover {
    transform: scale(1.1);
  }
}
.print {
  position: absolute;
  display: block;
  right: 250px;
  top: 330px;
  transition: all 0.2s ease-out;
  &:hover {
    transform: scale(1.1);
  }
}
.share {
  position: absolute;
  display: block;
  right: 50px;
  bottom: 200px;
  transition: all 0.2s ease-out;
  &:hover {
    transform: scale(1.1);
  }
}
</style>

<template>
  <div class="slide-10">
    <transition name="scale" appear>
      <img
        src="@/assets/module4/slide10/images.png"
        class="chars"
        v-show="slideIndex == 9"
      />
    </transition>
    <transition name="scale" appear>
      <div v-show="slideIndex == 9" class="delay-1">
        <h1>Now it’s nearly time<br />for our <span>puppet show!</span></h1>
      </div>
    </transition>
    <a :href="pdfLink1" class="download" target="_blank">
      <transition name="scale" appear>
        <img
          class="delay-2"
          src="@/assets/module4/slide10/download.png"
          v-show="slideIndex == 9"
          target="_blank"
        />
      </transition>
    </a>
    <a :href="pdfLink2" target="_blank" class="print">
      <transition name="scale" appear>
        <img
          class="delay-2"
          v-show="slideIndex == 9"
          src="@/assets/module4/slide10/print.png"
        />
      </transition>
    </a>
    <div class="content">
      <transition name="scale" appear>
        <p class="top delay-3" v-show="slideIndex == 9">
          First of all, can you download and make the finger puppets. You can
          decorate them with any crafts you have at home.
        </p>
      </transition>
      <transition name="scale" appear>
        <p v-show="slideIndex == 9" class="delay-4">
          Next download the puppet show script and see how much fun you can have
          acting out the show.
        </p>
      </transition>
      <transition name="scale" appear>
        <p v-show="slideIndex == 9" class="delay-5">
          You could ask your parent to film it and share with your Grandhero.
        </p>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    slideIndex: { type: Number }
  },
  data: function() {
    return {
      pdfLink1:
        window?.CF_EBOOK_VARS?.documents?.book_4_document_2?.url ||
        "https://fastheroes.com/wp-content/uploads/2020/06/Week-4-Cutout-Finger-Puppets-COLOUR-Asset-30.pdf",
      pdfId1:
        window?.CF_EBOOK_VARS?.documents?.book_4_document_2?.document_id ||
        "test_id",
      pdfLink2:
        window?.CF_EBOOK_VARS?.documents?.book_4_document_3?.url ||
        "https://fastheroes.com/wp-content/uploads/2020/06/Week-4-Puppet-Show-Script-COLOUR-Asset-31.pdf",
      pdfId2:
        window?.CF_EBOOK_VARS?.documents?.book_4_document_3?.document_id ||
        "test_id"
    };
  },
  methods: {}
};
</script>
